/**
 * A WhatsApp chat link (wa.me) to the operator, opening with a message already
 * written. Returns null when no number is set, so a button can simply not show.
 * The number is reduced to digits: wa.me wants no plus sign, spaces or dashes.
 */
export const whatsappLink = (number, message) => {
  const digits = String(number || "").replace(/\D/g, "");

  if (!digits) return null;

  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};
